import { Box, Button, Chip, Typography } from "@mui/material";
import { SharedStatus, Case, useCompanyQuery } from "services/GraphQl";
import { Business, Info, Person } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
interface CaseUserDetailsProps {
  companyId: string;
  userName: string;
  toggleEditDialog: () => void;
  toggleShareDialog: () => void;
  setCreateUserDialogOpen: (open: boolean) => void;
  setSyncUserDialogOpen: (open: boolean) => void;
  caseData: Case;
}

function CaseUserDetails({ companyId, userName, toggleEditDialog, toggleShareDialog, setCreateUserDialogOpen, setSyncUserDialogOpen, caseData }: CaseUserDetailsProps) {
  const navigate = useNavigate();
  const isCaseShared = caseData?.sharedStatus === SharedStatus.Shared;
  const shouldShowAddOrSyncUser = !caseData?.syncUser?.id && isCaseShared;  

  const { data: companyQuery } = useCompanyQuery({
    variables: { companyId: companyId ?? "" },
    skip: !companyId,
  });

  const company = companyQuery?.company;

  return (
    <>
      {company?.logo && (
        <Box
          component={"img"}
          src={company.logo}
          width={"200px"}
          sx={{
            mx: "auto",
          }}
        ></Box>
      )}
      
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="h3">{userName}</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button variant="contained" color="inherit" onClick={toggleEditDialog}>
                Edit Case
              </Button>
              <Button variant="contained" color="primary" onClick={toggleShareDialog}>
                {isCaseShared ? "Re-share Case" : "Share Case"}
              </Button>
              {shouldShowAddOrSyncUser && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setCreateUserDialogOpen(true);
                  }}
                >
                  Create User
                </Button>
              )}
              {shouldShowAddOrSyncUser && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setSyncUserDialogOpen(true);
                  }}
                >
                  Sync User to Case
                </Button>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Chip
              label={
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                  <Business /> <Typography>{caseData?.companyId}</Typography>
                </Box>
              }
            />
            {caseData?.childCompany?.name && (
              <Chip
                label={
                  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                    <Business /> <Typography>{caseData?.childCompany?.name}</Typography>
                  </Box>
                }
              />
            )}
            {caseData?.syncUser && (
              <Chip
                onClick={() => {
                  navigate(`/admin/users/${caseData?.syncUser?.id}`);
                }}
                label={
                  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                    <Person />
                    User Profile
                  </Box>
                }
              />
            )}
            {!caseData?.syncUser && (
              <Chip
                label={
                  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                    <Person />
                    No User
                  </Box>
                }
              />
            )}
            <Chip
              label={
                <Box
                  sx={{
                    color: ["active", "OPEN", "completed"].includes(caseData?.status) ? "success.main" : "error.main",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Info />
                  <Typography>{caseData?.status}</Typography>
                </Box>
              }
            />
          </Box>
        </Box>
    
    </>
  );
}

export default CaseUserDetails;
